import type {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {COMPETITION_CONTAINER} from "../../../../../containers/competition-container/competition-container.consts";
import type {CompetitionViewModel} from "../../../../../domain/common/competition/models/competition-view-model";
import {computed} from "mobx";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {HighlightsTabModel} from "../highlights.tab-model";
import {CompetitionHighlightsPageLinkModel} from "../../../../../containers/competition-container/pages/highlights-page/models/competition-highlights-page.link-model";

export class CompetitionHighlightsPageTabModel extends HighlightsTabModel {
  index: Number;
  name: String;
  entity: CompetitionViewModel;
  currentLinkModel: BaseLinkModel;

  constructor(
    index: Number,
    name: String,
    entity: CompetitionViewModel,
    currentLinkModel: BaseLinkModel
  ) {
    super(index, name)

    this.entity = entity;
    this.currentLinkModel = currentLinkModel;
  }

  @computed get linkModel(): CompetitionHighlightsPageLinkModel {
    const linkModel: CompetitionHighlightsPageLinkModel = new CompetitionHighlightsPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);

    return linkModel;
  }

  get isActive(): Boolean {
    return this.currentLinkModel.params.page === COMPETITION_CONTAINER.FILTERS.highlights;
  }

  get analyticsEntityType(): Object {
    return ANALYTICS.ENTITY_TYPES.competition;
  }
  get elementId(): String {
    return 'navigation-tabs_competition_highlights';
  }
}
